import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { MessageCircleQuestion, ArrowRight } from "lucide-react";
import { FAQ } from "@/lib/data";

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="section-y bg-white">
      <div className="container-x max-w-3xl">
        <div className="mb-12 text-center">
          <p className="overline mb-3">Questions fréquentes</p>
          <h2 className="text-3xl sm:text-4xl font-semibold text-secondary tracking-tight">
            On répond à vos questions.
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {FAQ.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-gray-100 bg-gray-50/60 px-6 data-[state=open]:bg-white data-[state=open]:border-primary/20 data-[state=open]:shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-semibold text-secondary hover:no-underline py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-12 flex flex-col items-center text-center gap-4" data-testid="faq-more-question">
          <div className="w-12 h-12 rounded-full bg-accent grid place-items-center">
            <MessageCircleQuestion className="w-6 h-6 text-primary" />
          </div>
          <p className="text-muted-foreground">Vous ne trouvez pas votre réponse ?</p>
          <Button
            asChild
            data-testid="faq-contact-cta"
            className="bg-primary hover:bg-primary/90 rounded-xl px-6 py-6 font-semibold group"
          >
            <a href="#contact">
              Une autre question ?
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
